import { commonShared } from 'com-ui/utilities/imagePath'
import { ProfileProps } from '@/profile/stores/store'
import { getPortalAvaiable } from './getPortalAvaiable'

interface PortalApp {
  icon: string
  name: string
  service : string
  link: string
  description: string
  enable?: boolean,
  group: string
}

export const getPortalApp = (profile?: ProfileProps): PortalApp[] => {
  if (profile == undefined) {
    return portalList
  }
  // const profile = useSelector(getProfileState)
  if (!profile?.roles) {
    return []
  }
  const portal = getPortalAvaiable(profile?.roles)
  const result = portalList.map((p) => (portal.includes(p?.group) ? { ...p, enable: true } : p))
  return result
}

const portalList: PortalApp[] = [
  {
    icon: `${commonShared('streaming-service.svg')}`,
    link: '/stream/live',
    service : 'service',
    name: 'name',
    description: 'description',
    group: 'stream'
  },
  {
    icon: `${commonShared('user-service.svg')}`,
    link: '/user/user',
    service : 'service',
    name: 'name',
    description: 'description',
    group: 'user'
  },
  {
    icon: `${commonShared('customer-support.svg')}`,
    link: '/admin/user',
    service : 'service',
    name: 'name',
    description: 'description',
    group: 'admin'
  },
  {
    icon: `${commonShared('payment-services-logo.svg')}`,
    link: '/wallet',
    service : 'service',
    name: 'name',
    description: 'description',
    group: 'wallet'
  },
  {
    icon: `${commonShared('vercel.svg')}`,
    link: '/setting',
    service : 'service',
    name: 'name',
    description: 'description',
    group: 'setting'
  },
  {
    icon: `${commonShared('vercel.svg')}`,
    link: '/game',
    service : 'service',
    name: 'name',
    description: 'description',
    group: 'game'
  }
]
